import { render } from "./Footer.vue?vue&type=template&id=817afd54&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=817afd54&scoped=true&lang=css"

import exportComponent from "/Users/matt/Dev/convict-memorial-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-817afd54"]])

export default __exports__